import React, { useEffect } from "react";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const StyledSwitch = styled("div")(({ state,options }) => ({
  width: 50, // Reduced width
  height: 24, // Reduced height
  position: "relative",
  borderRadius: 24 / 2,
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  backgroundColor:
    state === options[2]
      ? "#d4f8d4" // Light green for right
      : state === options[0]
      ? "#f8d4d4" // Light red for left
      : "#ddd", 
  transition: "background-color 0.3s",
  "& .thumb": {
    position: "absolute",
    width: 16, 
    height: 16,
    backgroundColor:
      state === options[2]
        ? "#4caf50" // Green for right
        : state === options[0]
        ? "#f44336" // Red for left
        : "#aaa", 
    borderRadius: "50%",
    boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
    transition: "transform 0.3s, background-color 0.3s",
    transform:
      state === options[0]
        ? "translateX(4px)" 
        : state === options[2]
        ? "translateX(30px)" 
        : "translateX(17px)", 
  },
}));

const ThreeWaySwitch = ({value, setValue,options=["left", "middle", "right"], leftSideText = "Left", rightSideText = "Right"}) => {

  const handleClick = (event) => {
    const switchElement = event.currentTarget;
    const switchRect = switchElement.getBoundingClientRect();
    const clickPosition = event.clientX - switchRect.left; // Click position relative to the switch

    if (clickPosition < switchRect.width / 3) {
      setValue(options[0]);
    } else if (clickPosition > (2 * switchRect.width) / 3) {
      setValue(options[2]);
    } else {
      setValue(options[1]);
    }
  };

  useEffect(() => {
  }, [value]);

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography>{leftSideText}</Typography>
      <StyledSwitch state={value} onClick={handleClick} options={options}>
        <div className="thumb" />
      </StyledSwitch>
      <Typography>{rightSideText}</Typography>
    </Stack>
  );
};

export default ThreeWaySwitch;
